import React, { useEffect, useState } from 'react'
import NavBar from '../Components/Main/NavBar'
import Footer from '../Components/Main/Footer'
import '../css/Item/Item.css'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import LoadingIcons from 'react-loading-icons';
import { useContext } from 'react'
import { CartContext } from '../Context/CartProvider'
import ProductGallery from '../Components/Item/ProductGallery'
import { AuthContext } from '../Context/AuthProvider';

const Item = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const navigate=useNavigate()
    const [product,setProduct] = useState(null);
    const [selectedColor, setSelectedColor] = useState();
    const [descriptionType,setDescriptionType]=useState("leiras");
    const {addToCart} = useContext(CartContext);
    const [quantity,setQuantity]=useState(1);
    const [ShortDesc,setShortDesc]=useState("");
    const [MediumDesc,setMediumDesc]=useState("");
    const [SpecsDesc,setSpecsDesc]=useState("");
    const {category, subcategory, id}=useParams();

    
    useEffect(() => {
        const API = process.env.REACT_APP_BACKEND_URL;
        const fetchProduct = async () => {
            try{
                const params = {};
            if (user && user.id) {
            params.id=id
            params.account_id = user.id;
            } else {
                params.id=id
            };
            const response = await axios.get(`${API}/wproduct`, {
            params
            });
            setProduct(response.data[0])
            setShortDesc(response.data[0].descriptions.short.replace(/\\n/g, '\n'));
            setMediumDesc(response.data[0].descriptions.medium.replace(/\\n/g, '\n'));
            setSpecsDesc(response.data[0].descriptions.specs.replace(/\\n/g, '\n'));
            if (response.data[0].colors.length > 0) {
                setSelectedColor(response.data[0].colors[0].name);
            }
            } catch(error){
                console.log(error)
            }
        }
        fetchProduct();
    },[id, user]);

    const handleCart = (e) => {
        e.stopPropagation();
        const cartItem = {
            id: Number(product.id), 
            item: product.name, 
            image: product.image,
            color: selectedColor ? selectedColor : null,
            price: Number(product.price), 
        };
        addToCart(cartItem, Number(quantity));
    };

    const handleChange = (event) => {
        setSelectedColor(event.target.value);
      };

  return (
    <div className='item-container'>
        <NavBar/>
        {product ? (
            <div>
            <div className='item-upper-container'>
            <div className='item-image-container'>
                <ProductGallery product={product}/>
            </div>
            <div className='item-info-container'>
                <p>{product.category.name} -- {product.subcategory.name}</p>
                <h1>{product.name}</h1>
                <p className={product.stock === 1 ? ("product-card-stock") : ("product-card-stock-none")}>{product.stock === 1 ? ("Raktáron") : ("Nincs Raktáron")}</p>
                {!user && product.discount_percentage > 0 && (<p className='wholeprice'>{Number(product.wholePrice).toLocaleString('hu-HU', { style: 'currency', currency: 'HUF' })}</p>)}
                {product.price > 0 ? (<h3>{Number(product.price).toLocaleString('hu-HU', { style: 'currency', currency: 'HUF' })}</h3>) : (null)}
                {product.price > 0 && (<p>(Áfát tartalmaz)</p>)}
                {product.colors.length > 0 && (
                    <select 
                    id="color" 
                    value={selectedColor} 
                    onChange={handleChange}
                >
                    {product.colors.map((color, index) => (
                    <option key={index} value={color.name}>
                        {color.name}
                    </option>
                    ))}
                </select>
                )}
                {product.price > 0 ? (<label>Mennyiség: </label>) : (null)}
                {product.price > 0 ? (<input type="number" placeholder='1' min={1} max={20} onChange={(e) => {setQuantity(e.target.value); console.log(quantity)}}/>) : (null)}
                {product.price > 0 ? (<button onClick={(e) => handleCart(e)}>Kosárba</button>) : (<button onClick={() => navigate('/kapcsolat',{ state: { product_name: product.name }})}>Ajánlatkérés</button>)}
            </div>
            </div>
            <div className='item-lower-container'>
                <div className='item-lower-short'>
                    <h2>Rövid Leírás</h2>
                    <p>{ShortDesc}</p>
                </div>
                <div className='item-lower-buttons'>
                    <button onClick={() => setDescriptionType("leiras")} className={descriptionType === "leiras" ? ('active') : ('inactive')}>Leírás</button>
                    <button onClick={() => setDescriptionType("spec")} className={descriptionType === "spec" ? ('active') : ('inactive')}>Specifikációk</button>
                </div>
                <div className='item-lower-desc'>
                    <p>
                        {descriptionType === "leiras" && (MediumDesc)}
                        {descriptionType === "spec" && (SpecsDesc)}
                    </p>
                </div>
            </div>
            </div>
        ) : (
            <div>
                <h1><LoadingIcons.Bars/></h1>
            </div>
        )}
        <Footer/>
    </div>
  )
}

export default Item